import { Anchor, Button, LoadingSpinner, AnnotateSVG } from "@newsela/angelou";
import { isEmpty } from "@s-libs/micro-dash";
import PropTypes from "prop-types";

import { useSchoolGet } from "@/school/hooks/useSchoolDetailsGet";
import {
  changeSchoolButtonCss,
  containerCss,
  schoolListCss,
} from "./PrincipalSchoolProfile.style";

const propTypes = {
  user: PropTypes.shape({
    principal: PropTypes.shape({
      school: PropTypes.shape({
        id: PropTypes.number.isRequired,
      }).isRequired,
    }),
  }).isRequired,
};

const PrincipalSchoolProfile = ({ user }) => {
  const { data: school, loading: isLoading } = useSchoolGet(
    user?.principal?.school?.id,
    { include_district: true },
  );

  if (isLoading) {
    return (
      <div css={containerCss}>
        <LoadingSpinner />
      </div>
    );
  }

  if (!school) {
    return (
      <div css={containerCss}>
        There is no school added yet.
        <Anchor
          flavor={Button.flavors.tertiary}
          size={Button.sizes.sm}
          icon={{
            SvgComponent: AnnotateSVG,
            alignment: Button.iconAlignments.left,
          }}
          __cssFor={changeSchoolButtonCss}
          href="/registration/school-search/?bypass-redirects=true&change-principal-only=true"
        >
          Add school
        </Anchor>
      </div>
    );
  }

  return (
    <div css={containerCss}>
      <h4>My school as a School Admin</h4>
      <ul role="list" css={schoolListCss}>
        <li>
          <strong>Name:</strong> {school?.name}
        </li>
        {!isEmpty(school?.address) && (
          <li>
            <strong>School address:</strong>
            <p>{school.address.address1}</p>
            <p>
              {school.address.city}, {school.address.state}
            </p>
            <p>{school.address.zip_code}</p>
          </li>
        )}
        {!isEmpty(school?.district) && (
          <li>
            <strong>District:</strong>{" "}
            {school.district.map((district) => district.name).join(", ")}
          </li>
        )}
      </ul>
    </div>
  );
};

PrincipalSchoolProfile.propTypes = propTypes;

export default PrincipalSchoolProfile;
